import { render, staticRenderFns } from "./VOpeningHoursBundle.vue?vue&type=template&id=0da2f44b"
import script from "./VOpeningHoursBundle.vue?vue&type=script&lang=ts"
export * from "./VOpeningHoursBundle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports